<template>
	<Col class="flex-align-start error-container flex-1 flex-justify-center">
		<Row class="title-text one-row text-align-left"> {{ title }} </Row>
		<Row class="description-text one-row text-align-left"> {{ description }} </Row>
	</Col>
</template>
<script>
import moment from 'moment';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { teamMemberByUserId } from '@/store/modules/account/getters';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service.js';
export default {
	name: 'AnalyticsLatestErrorItem',
	props: {
		title: { type: String },
		userId: { type: Number },
		createdAt: { type: String },
	},
	computed: {
		...mapGettersShorthand({ teamMemberByUserId }),
		description() {
			return `Triggered at ${this.timeAgo} By ${this.userFullName}`;
		},
		timeAgo() {
			return moment(new Date(this.createdAt)).format('YYYY-MM-DD HH:mm:ss');
		},
		user() {
			return this.teamMemberByUserId(this.userId);
		},
		userFullName() {
			return AppAvatarService.getUserFullName(this.user);
		},
	},
};
</script>
<style scoped lang="scss">
.title-text {
	font-size: 13px;
	font-weight: normal;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 12px;
	color: #abafb6;
	font-style: italic;
	letter-spacing: 0px;
}
.error-container {
	border-top: 1px solid #f0f1f3;
}
</style>
